module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_7005.c7c646ab.png";